import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./app/AppShell";
import { DashboardPage } from "./app/DashboardPage";
import { NewDemoPage } from "./app/NewDemoPage";
import { ProspectPage } from "./app/ProspectPage";
import { SettingsPage } from "./app/SettingsPage";
import { SignInPage } from "./app/SignInPage";
import { PortalPage } from "./portal/PortalPage";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/app" replace />} />
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/p/:token/*" element={<PortalPage />} />
      <Route path="/app" element={<AppShell />}>
        <Route index element={<DashboardPage />} />
        <Route path="new" element={<NewDemoPage />} />
        <Route path="prospects/:id" element={<ProspectPage />} />
        {/* Settings is reached from the My Demos header (superadmin only). */}
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/app" replace />} />
    </Routes>
  );
}
